import { Component } from "react";
import * as React from "react";
import { Route, Switch, withRouter } from "react-router";
import MainPage from "./pages/MainPage";
import TotalVotePage from "./pages/vote/TotalVotePage";
import MonthlyVotePage from "./pages/vote/MonthlyVotePage";
import WeeklyVotePage from "./pages/vote/WeeklyVotePage";
import ServerLevelsLeaderboardPage from "./pages/servers/ServerLevelsLeaderboardPage";
import CraftCoinsLeaderboard from "./pages/economy/CraftCoinsLeaderboard";
import CraftTokensLeaderboard from "./pages/economy/CraftTokensLeaderboard";
import VoteTokensLeaderboard from "./pages/economy/VoteTokensLeaderboard";
import QuestPointsLeaderboard from "./pages/economy/QuestPointsLeaderboard";
import PlaytimeLeaderboard from "./pages/economy/PlaytimeLeaderboard";
import EventPointsLeaderboard from "./pages/economy/EventPointsLeaderboard";
import FailedPage from "./components/Others/FailedPage";
import SkyblockIslandTopLeaderboard from "./pages/islands/SkyblockIslandTopLeaderboard";
import PlayerLookup from "./pages/player/PlayerLookup";
import HalloweenLeaderboard from "./pages/minigames/HalloweenLeaderboard";
import McMMOLeaderboardPage from "./pages/economy/mcmmo/McMMOLeaderboardPage";
import DragonSlayerLeaderboardPage from "./pages/servers/DragonSlayerLeaderboardPage";
import EconomyBalanceTopPage from "./pages/servers/EconomyBalanceTopPage";
import SeasonPointsLeaderboard from "./pages/economy/SeasonPointsLeaderboard";
import ReputationLeaderboard from './pages/economy/ReputationLeaderboard';

class MainRouter extends Component<any, any> {

	public render() {
		return (
			<Switch>
				<Route path="/" exact component={MainPage}/>

				{/* Vote routes */}
				<Route path="/leaderboard/votes/total" component={TotalVotePage}/>
				<Route path="/leaderboard/votes/month" component={MonthlyVotePage}/>
				<Route path="/leaderboard/votes/week" component={WeeklyVotePage}/>

				{/* McMMO routes */}
				<Route path="/leaderboard/mcmmo/survival/woodcutting"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'woodcutting'}
										headerText={'Survival McMMO: Leaderboard v dřevorubectví'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/swords"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'swords'}
										headerText={'Survival McMMO: Leaderboard v boji s mečem'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/taming"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'taming'}
										headerText={'Survival McMMO: Leaderboard v ochočování'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/mining"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'mining'}
										headerText={'Survival McMMO: Leaderboard v dolování'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/excavation"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'excavation'}
										headerText={'Survival McMMO: Leaderboard v kopání'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/repair"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'repair'}
										headerText={'Survival McMMO: Leaderboard v opravování'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/unarmed"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'unarmed'}
										headerText={'Survival McMMO: Leaderboard v neozbrojeném boji'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/herbalism"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'herbalism'}
										headerText={'Survival McMMO: Leaderboard v bylinkářství'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/archery"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'archery'}
										headerText={'Survival McMMO: Leaderboard v lukostřelbě'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/axes"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'axes'}
										headerText={'Survival McMMO: Leaderboard v sekerách'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/acrobatics"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'acrobatics'}
										headerText={'Survival McMMO: Leaderboard v akrobacii'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/fishing"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'fishing'}
										headerText={'Survival McMMO: Leaderboard v rybaření'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/alchemy"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'alchemy'}
										headerText={'Survival McMMO: Leaderboard v alchemii'}/>}
				/>
				<Route path="/leaderboard/mcmmo/survival/total"
						render={() => <McMMOLeaderboardPage server={'survival'} abilityType={'total'}
										headerText={'Survival McMMO: Celkový leaderboard hráčů dle levelů'}/>}
				/>

				<Route path="/leaderboard/mcmmo/skyblock/woodcutting"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'woodcutting'}
										headerText={'Skyblock McMMO: Leaderboard v dřevorubectví'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/swords"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'swords'}
										headerText={'Skyblock McMMO: Leaderboard v boji s mečem'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/taming"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'taming'}
										headerText={'Skyblock McMMO: Leaderboard v ochočování'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/mining"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'mining'}
										headerText={'Skyblock McMMO: Leaderboard v dolování'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/excavation"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'excavation'}
										headerText={'Skyblock McMMO: Leaderboard v kopání'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/repair"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'repair'}
										headerText={'Skyblock McMMO: Leaderboard v opravování'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/unarmed"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'unarmed'}
										headerText={'Skyblock McMMO: Leaderboard v neozbrojeném boji'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/herbalism"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'herbalism'}
										headerText={'Skyblock McMMO: Leaderboard v bylinkářství'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/archery"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'archery'}
										headerText={'Skyblock McMMO: Leaderboard v lukostřelbě'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/axes"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'axes'}
										headerText={'Skyblock McMMO: Leaderboard v sekerách'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/acrobatics"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'acrobatics'}
										headerText={'Skyblock McMMO: Leaderboard v akrobacii'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/fishing"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'fishing'}
										headerText={'Skyblock McMMO: Leaderboard v rybaření'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/alchemy"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'alchemy'}
										headerText={'Skyblock McMMO: Leaderboard v alchemii'}/>}
				/>
				<Route path="/leaderboard/mcmmo/skyblock/total"
						render={() => <McMMOLeaderboardPage server={'skyblock'} abilityType={'total'}
										headerText={'Skyblock McMMO: Celkový leaderboard hráčů dle levelů'}/>}
				/>

				{/* Server routes */}
				<Route path="/leaderboard/server/vanilla"
						render={() => <ServerLevelsLeaderboardPage
							disablePercentage={false}
							serverType={'vanilla'}
							headerText={'Seznam nejlepších hráčů z serveru Vanilla'}
						/>}
				/>
				<Route path="/leaderboard/server/creative"
						render={() => <ServerLevelsLeaderboardPage
							disablePercentage={false}
							serverType={'creative'}
							headerText={'Seznam nejlepších hráčů z serveru Creative'}
						/>}
				/>
				<Route path="/leaderboard/server/survival"
						render={() => <ServerLevelsLeaderboardPage
							disablePercentage={false}
							serverType={'survival'}
							headerText={'Seznam nejlepších hráčů z serveru Survival'}
						/>}
				/>
				<Route path="/leaderboard/server/skyblock"
						render={() => <ServerLevelsLeaderboardPage
							disablePercentage={false}
							serverType={'skyblock'}
							headerText={'Seznam nejlepších hráčů z serveru Skyblock'}
						/>}
				/>
				<Route path="/leaderboard/server/global"
						render={() => <ServerLevelsLeaderboardPage
							disablePercentage={true}
							serverType={'global'}
							headerText={'Žebříček hráčů s nejvyšším globálním levelem'}
						/>}
				/>
				<Route path="/leaderboard/server/old/prison_116"
						render={() => <ServerLevelsLeaderboardPage
							disablePercentage={false}
							serverType={'prison'}
							headerText={'Seznam nejlepších hráčů z serveru Prison'}
						/>}
				/>
				<Route path="/leaderboard/server/old/skycloud"
						render={() => <ServerLevelsLeaderboardPage
							disablePercentage={false}
							serverType={'skycloud'}
							headerText={'Seznam nejlepších hráčů z serveru SkyCloud'}
							headerWarning={'Tento server již není dostupný ke hraní. Byl odebrán: Jaro 2021'}
						/>}
				/>
				<Route path="/leaderboard/server/old/hardcore-vanilla"
						render={() => <ServerLevelsLeaderboardPage
							disablePercentage={false}
							serverType={'hardcore-vanilla'}
							headerText={'Seznam nejlepších hráčů z serveru Hardcore Vanilla'}
							headerWarning={'Tento server již není dostupný ke hraní. Byl odebrán: Jaro 2021'}
						/>}
				/>
				<Route path={"/leaderboard/server/old/vanilla_116"}
						render={() => <ServerLevelsLeaderboardPage
							disablePercentage={false}
							serverType={'vanilla_116'}
							headerText={'Seznam nejlepších hráčů z serveru Vanilla [1.16]'}
							headerWarning={'Tento server již není dostupný ke hraní. Byl odebrán: Léto 2021 (Update na 1.17)'}
						/>}
				/>

				<Route path="/leaderboard/survival/balance" exact={true}
						render={() => <EconomyBalanceTopPage
							serverType={'survival'}
							headerText={'Survival: Nejbohatší hráči'}
						/>}
				/>

				<Route path="/leaderboard/skyblock/balance" exact={true}
						render={() => <EconomyBalanceTopPage
							serverType={'skyblock'}
							headerText={'Skyblock: Nejbohatší hráči'}
						/>}
				/>

				<Route path="/leaderboard/skyblock/islands" component={SkyblockIslandTopLeaderboard}/>
				<Route path="/leaderboard/vanilla/dragon-slayer" component={DragonSlayerLeaderboardPage}/>

				{/* Economy routes */}
				<Route path="/leaderboard/economy/craft-coins" component={CraftCoinsLeaderboard}/>
				<Route path="/leaderboard/economy/craft-tokens" component={CraftTokensLeaderboard}/>
				<Route path="/leaderboard/economy/vote-tokens" component={VoteTokensLeaderboard}/>
				<Route path="/leaderboard/economy/quest-points" component={QuestPointsLeaderboard}/>
				<Route path="/leaderboard/economy/played-time" component={PlaytimeLeaderboard}/>
				<Route path="/leaderboard/economy/event-points" component={EventPointsLeaderboard}/>
				<Route path="/leaderboard/economy/season-points" component={SeasonPointsLeaderboard}/>
				<Route path="/leaderboard/reputation" component={ReputationLeaderboard}/>

				<Route path="/player/:nick" component={PlayerLookup}/>

				{/* Minigames */}
				<Route path="/minigames/halloween" component={HalloweenLeaderboard}/>

				<Route component={FailedPage}/>
			</Switch>
		);
	}
}

export default withRouter(MainRouter);
